var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.kind,style:(_vm.dataStyle),attrs:{"title":_vm.dataTitle,"href":_vm.path,"target":_vm.dataTarget}},[_c('i',{class:_vm.icon}),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }